import {
  computed,
  Injectable,
  resource,
  ResourceRef,
  Signal,
} from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ICountry } from '@web/dtos';
import { IApiResponse } from '@web/shared-types';
import { CountryGateway } from './country.gateway';

@Injectable({
  providedIn: 'root',
})
export class CountryStore {
  private readonly gateway: CountryGateway = new CountryGateway();

  #countryResource: ResourceRef<IApiResponse<ICountry[]> | undefined> =
    resource({
      loader: (): Promise<IApiResponse<ICountry[]>> => {
        return firstValueFrom(this.gateway.get());
      },
    });
  readonly isLoading: Signal<boolean> = computed((): boolean =>
    this.#countryResource.isLoading()
  );
  readonly countries: Signal<ICountry[]> = computed(() => {
    if (this.#countryResource.hasValue()) {
      const data: ICountry[] = this.#countryResource.value()
        ?.data as unknown as ICountry[];
      return data ?? [];
    }
    return [];
  });

  reload(): void {
    this.#countryResource.reload();
  }
}
